import React from 'react';
import { TextField, Typography } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { ConfigFieldControl } from '@sierralabs/core-ui';
import SiteQueryFieldPicker from '../../common/pickers/SiteQueryFieldPicker';
import { useConfigComponent } from '../../hooks/component/useConfigComponent';
import { useQueryDisplayValue } from '../../hooks/component/useQueryDisplayValue';
import { useSubscribeComponentChanges } from '../../hooks/component/useSubscribeComponentChanges';
import { useSiteContext } from '../../SiteContext';
import { SiteComponent } from '../SiteComponentPlugin';
import { useGetQueriesForComponentTree } from '../../hooks/component/useGetQueriesForComponentTree';
export const SiteText = props => {
    const component = useSubscribeComponentChanges(SiteTextPlugin, props);
    const { queryId, queryField, variant } = component.props || {};
    const { isHover, hoverProps } = useSiteContext();
    const value = useQueryDisplayValue(queryId, queryField, props.queryValueProps);
    // format value to remove html tags
    const formattedValue = value === null || value === void 0 ? void 0 : value.replace(/(<([^>]+)>)/gi, '');
    const classes = ['site-text'];
    if (isHover(component)) {
        classes.push('component-hover');
    }
    return (React.createElement(SiteComponent, Object.assign({ plugin: SiteTextPlugin }, props), variant ? (React.createElement(Typography, Object.assign({ variant: variant, className: classes.join(' ') }, hoverProps(component)), formattedValue)) : (formattedValue)));
};
const variants = [
    'body1',
    'body2',
    'button',
    'caption',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'inherit',
    'overline',
    'srOnly',
    'subtitle1',
    'subtitle2'
];
export const SiteTextConfigurator = props => {
    var _a, _b, _c;
    const { component, update } = useConfigComponent(props.component);
    const queries = useGetQueriesForComponentTree(component);
    return (React.createElement(React.Fragment, null,
        React.createElement(ConfigFieldControl, null,
            React.createElement(SiteQueryFieldPicker, { queryId: (_a = component.props) === null || _a === void 0 ? void 0 : _a.queryId, queryField: (_b = component.props) === null || _b === void 0 ? void 0 : _b.queryField, options: queries, onChange: value => {
                    update('props.queryId', value.queryId);
                    update('props.queryField', value.queryField);
                } })),
        React.createElement(ConfigFieldControl, null,
            React.createElement(Autocomplete, { fullWidth: true, forcePopupIcon: true, options: variants, value: ((_c = component.props) === null || _c === void 0 ? void 0 : _c.variant) || null, onChange: (_, value) => update('props.variant', value || undefined), renderInput: params => (React.createElement(TextField, Object.assign({}, params, { fullWidth: true, size: 'small', label: 'Variant', helperText: 'Select a Typography', InputProps: Object.assign(Object.assign({}, params.InputProps), { disableUnderline: true }) }))) }))));
};
export const SiteTextPlugin = {
    name: 'Text',
    type: 'text',
    component: SiteText,
    configurator: SiteTextConfigurator
};
//# sourceMappingURL=SiteTextPlugin.js.map